module.exports = __webpack_public_path__ + "img/ol.f4b9fae2.svg";